// extracted by mini-css-extract-plugin
module.exports = {"item":"Navigation_item__ABade","selected":"Navigation_selected___XV23"};